import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {

};

export type I18nDigitCode = typeof _fr;

const _en: I18nDigitCode = {

};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nDigitCode {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}